import React from "react"
import { createBrowserRouter, Navigate, Outlet } from "react-router"
import DashboardLayout from "./components/layouts/DashboardLayout"
import MainLayout from "./components/layouts/MainLayout"
import GeneralStatistics from "./pages/dashboard/GeneralStatistics"
// Lazy load the components
const CarDetails = React.lazy(() => import("./pages/details"))
const Landing = React.lazy(() => import("./pages/landing"))
const ViewAllPage = React.lazy(() => import("./pages/viewall"))
const SignInComponent = React.lazy(() => import("./components/SignInComponent"))
const Page404 = React.lazy(() => import("./pages/404"))
const ViewAllCars = React.lazy(() => import("./pages/dashboard/ViewAllCars"))

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      {
        path: "/",
        element: <Landing />,
      },
      {
        path: "/carros/page/:id",
        element: <ViewAllPage />,
      },
      {
        path: "/carros/:id",
        element: <CarDetails />,
      },
    ],
  },
  {
    path: "/admin",
    element: (
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    ),
    children: [
      {
        index: true, // The default route for /admin will redirect to /admin/page/:id
        path: "/admin",
        element: <Navigate to="/admin/stats" />, // You can change the ID as needed
      },
      {
        path: "/admin/stats",
        element: <GeneralStatistics />,
      },
      {
        path: "/admin/carros/page/:id",
        element: <ViewAllCars />,
      },
      {
        path: "/admin/archivo/page/:id",
        element: <ViewAllCars />,
      },
    ],
  },
  {
    path: "sign-in/*",
    element: <SignInComponent />,
  },
  {
    path: "*",
    element: (
      <MainLayout>
        <Page404 />
      </MainLayout>
    ),
  },
])

export default router
